import type { FaireProductEntity } from "../../entity_types/product";

export const p_ffvrg98xf2: FaireProductEntity = {
  token: "p_ffvrg98xf2",
  type: "product",
  name: "Femme Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/0f46d5d8c5f4ceb3c0299cd430d2e17d174df50f3a5cd5f4fd8917f9f83fc44d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b086f2107122491610a1d67c61105d115888aaf0a81caf5969e6d2b2047d2dd7.jpeg",
    "https://cdn.faire.com/fastly/aeb483618f943885a91a6d28fb7bcc058e341ed5d9c30c13d4e9a17dc8557337.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/527440fe1d990349d88e5d50d33e6dc869e07a9468074c949955e19f2f49cf62.jpeg",
    "https://cdn.faire.com/fastly/66474870ed5b80dacc480fcf3b030c0ca742e8d150886b1b1b21be847efd78f2.jpeg"
  ],
  priceDollars: 6.75,
  description: "Go ahead and strut past the binary without slowing down. These socks didn't come out to blend in.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:28.983Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
